import { useLiveDataSubscriptions } from '#entities';

import type { PropsWithChildren } from 'react';

/**
 * Per-route live-data anchor: mounts the eight core live queries for the route's
 * lifetime so their polling cadence and nop-events refetches stay alive
 * regardless of which widgets are on screen. Renders no context.
 */
export const DataProvider = ({ children }: PropsWithChildren) => {
  useLiveDataSubscriptions();

  return <>{children}</>;
};
